import { ref, onMounted, onBeforeUnmount } from 'vue-demi';
const { throttle, rem: { rem } } = require('@futuweb/fego-bridge');

export function useHeaderFixed({ horizontalTabRef, props }) {
    const shouldFixed = ref(false);

    const getTopOffset = ()=>{
        const docEl = document.documentElement;
        const topOffset = rem(props.tpl.props.fixedHeaderTopOffset || 0) * parseFloat(docEl.style.fontSize);
        return topOffset;
    };

    const checkShouldFixed = throttle(() => {
        const clientHeight = document.documentElement.clientHeight;
        const tabHeaderFake = horizontalTabRef.value.querySelector('.horizontal-tab-header-fake');
        const tabHeaderReal = horizontalTabRef.value.querySelector('.horizontal-tab-header-real');
        shouldFixed.value = false;

        // 获取 tabHeaderFake 和 horizontalTabRef 的边界矩形
        let { top: headerTop } = tabHeaderFake.getBoundingClientRect();
        let { top: tabTop, bottom: tabBottom } = horizontalTabRef.value.getBoundingClientRect();
        const topOffset = getTopOffset();
        // 加了偏移高度为正 等于是 头部变高了，那么头顶距离顶部变小了，需要做减法
        headerTop = headerTop - topOffset;
        tabTop = tabTop - topOffset;
        // 检查条件
        const headerIsAboveViewport = headerTop < 0;
        const tabHasContentInViewport = tabBottom > 0 && tabTop < clientHeight;
        const tabTopIsBelowHeaderHeight = tabBottom > tabHeaderReal.offsetHeight + topOffset + 30;

        // 设置 shouldFixed
        shouldFixed.value = headerIsAboveViewport && tabHasContentInViewport && tabTopIsBelowHeaderHeight;

        // 更新元素
        if (shouldFixed.value) {
            const height = tabHeaderReal.getBoundingClientRect().height;
            tabHeaderFake.style.height = height + 'px';
            tabHeaderReal.classList.add('horizontal-tab-fixed-header');
            tabHeaderReal.style.top = topOffset + 'px';
        } else {
            tabHeaderFake.style.height = 0 + 'px';
            tabHeaderReal.classList.remove('horizontal-tab-fixed-header');
            tabHeaderReal.style.top = 0 + 'px';
        }
    }, 50);

    const watchScroll = () => {
        window.addEventListener('scroll', checkShouldFixed);
    };

    const unWatchScroll = () => {
        window.removeEventListener('scroll', checkShouldFixed);
    };

    onMounted(() => {
        if (props.tpl.props.fixedHeader) {
            watchScroll();
        }
    });

    onBeforeUnmount(() => {
        unWatchScroll();
    });

    const scrollNavToVerticalTop = () => {
        const tabHeader = horizontalTabRef.value.querySelector('.horizontal-tab-header');
        const tabBody = horizontalTabRef.value.querySelector('.horizontal-tab-body');
        const navHeight = tabHeader.offsetHeight; // 导航栏高度
        const { y: y1 } = tabBody.getBoundingClientRect();
        const { y: y2 } = document.body.getBoundingClientRect();
        const top = -getTopOffset() + y1 - y2 - navHeight;

        // 滚动到目标位置
        window.scrollTo({ top: Math.round(top), behavior: 'smooth' });
    };

    return {
        shouldFixed,
        scrollNavToVerticalTop
    };
}
